import { KeyLabel } from '../../domain/key-label.model';

export enum UserRole {
  //types
  PUBLISHER = 'PUBLISHER',
  DEMAND_PARTNER = 'DEMAND_PARTNER',
  CM_USER = 'CM_USER',

  //publisher roles
  PB_FINANCE = 'PB_FINANCE',
  PB_ADOPS = 'PB_ADOPS',

  //kitchen roles
  KN_ADMIN = 'KN_ADMIN',
  KN_SALES_PERSON = 'KN_SALES_PERSON',
  KN_OPERATIONS = 'KN_OPERATIONS',
  KN_FINANCE = 'KN_FINANCE',
  KN_SYSTEM = 'KN_SYSTEM',
  KN_ACCOUNT_MANAGER = 'KN_ACCOUNT_MANAGER',
  KN_BID_ADJUSTMENTS = 'KN_BID_ADJUSTMENTS',
}

export const UserRoleLabels = {
  PUBLISHER: 'Publisher',
  DEMAND_PARTNER: 'Demand partner',
  CM_USER: 'Kitchen',

  //publisher roles
  PB_FINANCE: 'Pub. Finance',
  PB_ADOPS: 'Pub. Adops',

  //kitchen roles
  KN_SALES_PERSON: 'Kn. Sales person',
  KN_ADMIN: 'Kn. Admin',
  KN_OPERATIONS: 'Kn. Operations',
  KN_FINANCE: 'Kn. Finance',
  KN_SYSTEM: 'Kn. System',
  KN_ACCOUNT_MANAGER: 'Kn. Account manager',
  KN_BID_ADJUSTMENTS: 'Kn. Bid Adjustments',

};

export const UserRoleWithoutTypesKL = () =>
  (Object.keys(UserRole)
    .filter(role => ![UserRole.PUBLISHER, UserRole.DEMAND_PARTNER, UserRole.CM_USER].includes(<UserRole> role))
    .map(key => new KeyLabel(<UserRole>key, UserRoleLabels[key])));

export const PublisherRolesKL = () =>
  (Object.keys(UserRole)
    .filter(role => role.includes('PB_'))
    .map(key => new KeyLabel(<UserRole>key, UserRoleLabels[key])));

export const KitchenRolesKL = () =>
  (Object.keys(UserRole)
    .filter(role => role.includes('KN_'))
    .map(key => new KeyLabel(<UserRole>key, UserRoleLabels[key])));
